export type VuexRootActionNameList =
  | "CHECK_APP_HASH"
  | "CLEAR_LOCAL_STORAGE"
  | "DETERMINE_ANDROID_APP_VERSION"
  | "DETERMINE_IOS_APP_VERSION"
  | "FETCH_DETAILS"
  | "LOGOUT_REQUEST"
  | "MANAGE_DEVICE_UUID"
  | "ONE_SIGNAL_GET_CTA_INTERACTION_LOG"
  | "ONE_SIGNAL_GET_NOTIFICATION_PERMISSION"
  | "ONE_SIGNAL_DELETE_ALL_TAGS"
  | "ONE_SIGNAL_INIT"
  | "ONE_SIGNAL_RECORD_CTA_INTERACTION"
  | "ONE_SIGNAL_REMOVE_EXTERNAL_USER_ID"
  | "ONE_SIGNAL_SEND_TAGS"
  | "ONE_SIGNAL_SET_EXTERNAL_USER_ID"
  | "ONE_SIGNAL_SET_SUBSCRIPTION"
  | "PUSH_NOTIFICATION_TOAST"
  | "SHIFT_NOTIFICATION_TOAST"
  | "SAVE_OPENED_CHAPTER"
  | "SAVE_PREVIOUS_ROUTE"
  | "SAVE_SELECTED_SKILL_LEVEL_INDEXES";
export type VuexRootActionNames = {
  [T in VuexRootActionNameList]: string;
};

export type VuexRootMutationNameList =
  | "ANDROID_APP_VERSION"
  | "IOS_APP_VERSION"
  | "APP_VERSION_ALERT"
  | "BOOKMARKED_COURSE_LIMIT_MULTIPLIER"
  | "COURSE_EXPLORE_SEARCH_STRING"
  | "COURSE_EXPLORE_SELECTED_CATEGORY_IDS"
  | "COURSE_EXPLORE_SELECTED_EXAM_INDEX"
  | "COURSE_EXPLORE_SELECTED_LEVEL_INDEXES"
  | "DEVICE_UUID"
  | "GROUP_COURSE_LIMIT_MULTIPLIER"
  | "GROUP_COURSE_SELECTED_CATEGORY_IDS"
  | "GROUP_COURSE_SELECTED_EXAM_INDEX"
  | "GROUP_COURSE_SELECTED_GROUP_INDEX"
  | "GROUP_COURSE_SELECTED_LEVEL_INDEXES"
  | "LEARNING_HISTORY_END_DATE"
  | "LEARNING_HISTORY_START_DATE"
  | "LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL"
  | "MAINTENANCE_MODE"
  | "NOTIFICATION_TOASTS"
  | "ONE_SIGNAL_CTA_INTERACTION"
  | "ONE_SIGNAL_INITIALIZED"
  | "ONE_SIGNAL_NOTIFICATION_PERMISSION"
  | "OPENED_CHAPTERS"
  | "PREVIOUS_ROUTE"
  | "SELECTED_SKILL_LEVEL_INDEXES";
export type VuexRootMutationNames = {
  [T in VuexRootMutationNameList]: string;
};

export type VuexRootGetterNameList =
  | "CAN_GO_BACK"
  | "AUTH_INFO"
  | "BOOKMARKED_COURSE_LIMIT_MULTIPLIER"
  | "COURSE_EXPLORE_SEARCH_STRING"
  | "COURSE_EXPLORE_SELECTED_CATEGORY_IDS"
  | "COURSE_EXPLORE_SELECTED_EXAM_INDEX"
  | "COURSE_EXPLORE_SELECTED_LEVEL_INDEXES"
  | "FLAT_EXERCISE_LIST"
  | "GROUP_COURSE_LIMIT_MULTIPLIER"
  | "GROUP_COURSE_SELECTED_CATEGORY_IDS"
  | "GROUP_COURSE_SELECTED_EXAM_INDEX"
  | "GROUP_COURSE_SELECTED_GROUP_INDEX"
  | "GROUP_COURSE_SELECTED_LEVEL_INDEXES"
  | "LEARNING_HISTORY_END_DATE"
  | "LEARNING_HISTORY_START_DATE"
  | "LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL"
  | "OPENED_CHAPTERS"
  | "PREVIOUS_ROUTE"
  | "SELECTED_SKILL_LEVEL_INDEXES";
export type VuexRootGetterNames = {
  [T in VuexRootGetterNameList]: string;
};

export const VUEX_LOCALSTORAGE_KEYS = {
  BOOKMARKED_COURSE_LIMIT_MULTIPLIER: "bookmarked_course_limit_multiplier",
  COURSE_EXPLORE_SEARCH_STRING: "course_explore_search_string",
  COURSE_EXPLORE_SELECTED_CATEGORY_IDS: "course_explore_selected_category_ids",
  COURSE_EXPLORE_SELECTED_EXAM_INDEX: "course_explore_selected_exam_index",
  COURSE_EXPLORE_SELECTED_LEVEL_INDEXES: "course_explore_selected_level_indexes",
  GROUP_COURSE_LIMIT_MULTIPLIER: "group_course_limit_multiplier",
  GROUP_COURSE_SELECTED_EXAM_INDEX: "group_course_selected_exam_index",
  GROUP_COURSE_SELECTED_GROUP_INDEX: "group_course_selected_group_index",
  GROUP_COURSE_SELECTED_CATEGORY_IDS: "group_course_selected_category_ids",
  GROUP_COURSE_SELECTED_LEVEL_INDEXES: "group_course_selected_level_indexes",
  LEARNING_HISTORY_END_DATE: "learning_history_end_date",
  LEARNING_HISTORY_START_DATE: "learning_history_start_date",
  LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL:
    "learning_history_selected_exercise_type_and_skill"
};

export const VUEX_PERSISTENT_LOCALSTORAGE_KEYS = {
  CTA_INTERACTION: "cta_interaction",
  DEVICE_UUID: "device_uuid",
  OPENED_CHAPTERS: "opened_chapters",
  SELECTED_SKILL_LEVEL_INDEXES: "selected_skill_level_indexes"
};

export const VUEX_ROOT_ACTION_NAMES: VuexRootActionNames = {
  CHECK_APP_HASH: "check_app_hash",
  CLEAR_LOCAL_STORAGE: "clear_local_storage",
  DETERMINE_ANDROID_APP_VERSION: "determine_android_app_version",
  DETERMINE_IOS_APP_VERSION: "determine_ios_app_version",
  FETCH_DETAILS: "fetch_details",
  LOGOUT_REQUEST: "logout_request",
  MANAGE_DEVICE_UUID: "manage_device_uuid",
  ONE_SIGNAL_GET_CTA_INTERACTION_LOG: "one_signal_get_cta_interaction_log",
  ONE_SIGNAL_GET_NOTIFICATION_PERMISSION: "one_signal_get_notification_permission",
  ONE_SIGNAL_DELETE_ALL_TAGS: "one_signal_delete_all_tags",
  ONE_SIGNAL_INIT: "one_signal_init",
  ONE_SIGNAL_RECORD_CTA_INTERACTION: "one_signal_record_cta_interaction",
  ONE_SIGNAL_REMOVE_EXTERNAL_USER_ID: "one_signal_remove_external_user_id",
  ONE_SIGNAL_SEND_TAGS: "one_signal_send_tags",
  ONE_SIGNAL_SET_EXTERNAL_USER_ID: "one_signal_set_external_user_id",
  ONE_SIGNAL_SET_SUBSCRIPTION: "one_signal_set_subscription",
  PUSH_NOTIFICATION_TOAST: "push_notification_toast",
  SHIFT_NOTIFICATION_TOAST: "shift_notification_toast",
  SAVE_OPENED_CHAPTER: "save_opened_chapter",
  SAVE_PREVIOUS_ROUTE: "save_previous_route",
  SAVE_SELECTED_SKILL_LEVEL_INDEXES: "save_selected_skill_level_indexes"
};

export const VUEX_ROOT_MUTATION_NAMES: VuexRootMutationNames = {
  ANDROID_APP_VERSION: "android_app_version",
  APP_VERSION_ALERT: "app_version_alert",
  BOOKMARKED_COURSE_LIMIT_MULTIPLIER: "bookmarked_course_limit_multiplier",
  COURSE_EXPLORE_SEARCH_STRING: "course_explore_search_string",
  COURSE_EXPLORE_SELECTED_CATEGORY_IDS: "course_explore_selected_category_ids",
  COURSE_EXPLORE_SELECTED_EXAM_INDEX: "course_explore_selected_exam_index",
  COURSE_EXPLORE_SELECTED_LEVEL_INDEXES: "course_explore_selected_level_indexes",
  DEVICE_UUID: "device_uuid",
  GROUP_COURSE_LIMIT_MULTIPLIER: "group_course_limit_multiplier",
  GROUP_COURSE_SELECTED_CATEGORY_IDS: "group_course_selected_category_ids",
  GROUP_COURSE_SELECTED_EXAM_INDEX: "group_course_selected_exam_index",
  GROUP_COURSE_SELECTED_GROUP_INDEX: "group_course_selected_group_index",
  GROUP_COURSE_SELECTED_LEVEL_INDEXES: "group_course_selected_level_indexes",
  IOS_APP_VERSION: "ios_app_version",
  LEARNING_HISTORY_END_DATE: "learning_history_end_date",
  LEARNING_HISTORY_START_DATE: "learning_history_start_date",
  LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL:
    "learning_history_selected_exercise_type_and_skill",
  MAINTENANCE_MODE: "MAINTENANCE_MODE",
  NOTIFICATION_TOASTS: "notification_toasts",
  OPENED_CHAPTERS: "opened_chapters",
  ONE_SIGNAL_CTA_INTERACTION: "one_signal_cta_interaction",
  ONE_SIGNAL_NOTIFICATION_PERMISSION: "one_signal_notification_permission",
  ONE_SIGNAL_INITIALIZED: "one_signal_initialized",
  PREVIOUS_ROUTE: "previous_route",
  SELECTED_SKILL_LEVEL_INDEXES: "selected_skill_level_indexes"
};

export const VUEX_ROOT_GETTER_NAMES: VuexRootGetterNames = {
  CAN_GO_BACK: "can_go_back",
  AUTH_INFO: "auth_info",
  BOOKMARKED_COURSE_LIMIT_MULTIPLIER: "bookmarked_course_limit_multiplier",
  COURSE_EXPLORE_SEARCH_STRING: "course_explore_search_string",
  COURSE_EXPLORE_SELECTED_CATEGORY_IDS: "course_explore_selected_category_ids",
  COURSE_EXPLORE_SELECTED_EXAM_INDEX: "course_explore_selected_exam_index",
  COURSE_EXPLORE_SELECTED_LEVEL_INDEXES: "course_explore_selected_level_indexes",
  FLAT_EXERCISE_LIST: "flat_exercise_list",
  GROUP_COURSE_LIMIT_MULTIPLIER: "group_course_limit_multiplier",
  GROUP_COURSE_SELECTED_CATEGORY_IDS: "group_course_selected_category_ids",
  GROUP_COURSE_SELECTED_EXAM_INDEX: "group_course_selected_exam_index",
  GROUP_COURSE_SELECTED_GROUP_INDEX: "group_course_selected_group_index",
  GROUP_COURSE_SELECTED_LEVEL_INDEXES: "group_course_selected_level_indexes",
  LEARNING_HISTORY_END_DATE: "learning_history_end_date",
  LEARNING_HISTORY_START_DATE: "learning_history_start_date",
  LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL:
    "learning_history_selected_exercise_type_and_skill",
  OPENED_CHAPTERS: "opened_chapters",
  PREVIOUS_ROUTE: "previous_route",
  SELECTED_SKILL_LEVEL_INDEXES: "selected_skill_level_indexes"
};

export enum TWAStatus {
  NOT_TWA = "NOT_TWA",
  NO_VERSION = "NO_VERSION"
}
